import { ReactNode } from "react";
import { Mission2, UiComponent } from "./Types";
export const w = window as any;


export class Action {
    run (mission: Mission2, taskId: number | null | undefined, setUiComponent: (component: ReactNode) => void ) {};
}

export class SwitchState extends Action {
    constructor(private targetState: number) {
        super();
    }

    run(mission: Mission2) {
        const targetState =  this.targetState;

        if(targetState && mission) {
            mission.currentState.id = targetState;

            const updatedMission = { ...mission };
            w.localStorageController.addMissionToLocalStorage(updatedMission);
            w.XopsGlobals.getInstance().currentView.refreshModel();
        }
    }
}

// Action to be programmed
export class MarkEventAsNotification extends Action {
    constructor(private notificationType: string) { super(); }

    run() {
        //setState(targetState);
        const notificationType =  this.notificationType;
        console.log("MarkEventAsNotificationthis", notificationType)
    }
}

// Action that switches the state of an object
export class SwitchObjectState extends Action {
    constructor(private targetState: number) { 
        super(); }

    run(mission: Mission2, taskId: number | null | undefined) {
        const targetState =  this.targetState;
        if(targetState && mission && taskId) {
            const objectIndex = mission.objectActionGroups.findIndex((object) => object.id === taskId)
            if(objectIndex !== -1){
                mission.objectActionGroups[objectIndex].object.currentState.id = targetState

                
                const updatedMission = { ...mission};
            
                w.localStorageController.addMissionToLocalStorage(updatedMission);
             /*if the id equals the id of the mission, that means the action
            is called by the mission and not the object. In this case we will update 
            the state of every object of the currentStop in that mission */
            }else {
                const updatedMission = mission;
                const stopIndex = updatedMission.stops.findIndex((stop: any) => mission.currentStopId === stop.id);
                if(stopIndex !== -1) {
                    updatedMission.objectActionGroups.forEach((objectAction: any) => {
                        objectAction.object.currentState.id = targetState;
                    });
        
                    w.localStorageController.addMissionToLocalStorage(updatedMission);
                }
            }
    }
    w.XopsGlobals.getInstance().currentView.refreshModel();
    }
}

// Switches the status of the mission
export class SwitchMissionStatus extends Action {
    constructor(private targetStatus: string) {
        super();
    }

    run(mission: Mission2) {
        const targetStatus =  this.targetStatus;

        if(targetStatus && mission) {

            mission.status = targetStatus;

            const updatedMission = { ...mission};

            w.localStorageController.addMissionToLocalStorage(updatedMission);
            w.XopsGlobals.getInstance().currentView.refreshModel();
        }
    }
}

// Switches the start time of the mission to the current time
export class ChangeMissionStartTime extends Action {
    //constructor() {super();}

    run(mission: Mission2) {
        if(mission) {

            mission.startTime = Date.now();


            const updatedMission = { ...mission};

            w.localStorageController.addMissionToLocalStorage(updatedMission);
        }
    }
}

// Switches the status of the current stop
export class SwitchStopStatus extends Action {
    constructor(private targetStatus: string) { super(); }

    run(mission: Mission2) {
        const targetStatus =  this.targetStatus;
        if(targetStatus && mission) {
            const updatedMission = mission;
            const stopIndex = updatedMission.stops.findIndex((stop: any) => mission.currentStopId === stop.attributes.id);
            if(stopIndex !== -1) {
                updatedMission.stops[stopIndex].status = targetStatus;

                w.localStorageController.addMissionToLocalStorage({...updatedMission});
            }
        }
    }
}

// Action to be programmed
export class OneTimeEvent extends Action {
    //constructor() { super(); }

    run() {
        console.log("OneTimeEvent")
    }
}

// Sets the desired UI in the modal
export class ButtonActionWithUi extends Action {

    uiComponents!: ReactNode[];

    run(mission: Mission2, taskId: number, setUiComponent: (component: ReactNode) => void ) {
        
        const UiComponent = this.uiComponents[0]
        
        setUiComponent(UiComponent)

        }
    }